import { RootState } from "@/redux/store";

export const countryStatesSelector = (state: RootState) => state.resource.states;
